// Import components
import GLightbox from "glightbox";
import headerHeight from "./headerHeight.js";
import { initHamburger } from "./components/hamburger.js";
import { initSubMenuToggle } from "./components/menu.js";
import { initListButtons } from "./components/list-buttons.js";
import { initListButtonsAlt } from "./components/list-buttons-alt.js";
import { initButtonTabs } from "./components/buttons-tabs.js";

// Init
document.addEventListener("DOMContentLoaded", () => {
	// lightview image vide
	const lightbox = GLightbox({
		selector: ".glightbox",
		// Désactive le préchargement des slides voisines : avec autoplay=1 sur les
		// embeds YouTube, GLightbox chargeait aussi l'iframe suivante/précédente
		// en arrière-plan, ce qui la faisait démarrer en même temps dans la galerie.
		preload: false
	});

	// ----header
	headerHeight();
	initSubMenuToggle();
	initHamburger();
	initListButtons();
	initListButtonsAlt();
	initButtonTabs();
});
